import { render, staticRenderFns } from "./ContestAllySectionComponent.vue?vue&type=template&id=570119a0"
import script from "./ContestAllySectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestAllySectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestAllySectionComponent.vue?vue&type=style&index=0&id=570119a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports